<template>
    <div class="form-inline justify-content-between">
        <div>
            <div><span>{{bot.name}}</span></div>
            <div class="text-muted small"><a target="_blank" :href="'https://t.me/' + bot.username">@{{bot.username}}</a></div>
        </div>
        <div>
            {{PlatformHelper.get(bot.platform_id).name}}
        </div>
        <div>
            <span v-if="bot.is_active" class="badge badge-success">Подключен</span> <span v-if="!bot.is_active" class="badge badge-danger">Ошибка</span>
        </div>
        <div>
            <button type="button" @click.prevent="visibleSettings = true" class="btn btn-primary btn-sm">Редактировать</button>
        </div>
        <el-dialog v-if="visibleSettings" :visible.sync="visibleSettings" @close="handlerCloseSettings" :title="'Редактирование  ' + bot.name" :append-to-body="true" width="400px">
            <BotForm @updated="handlerUpdated" :bot_id="bot.id" />
        </el-dialog>
    </div>
</template>

<script>
import BotForm from "./BotForm.vue";
import PlatformHelper from "../../helpers/platform";

export default {
    name: "BotManageListItem",
    computed: {
        PlatformHelper() {
            return PlatformHelper
        }
    },
    components: {BotForm},
    props: ['bot'],
    data: () => ({
        isLoading: false,
        visibleSettings: false,
        visibleUsers: false,
    }),
    mounted() {

    },
    methods: {
        handlerCloseSettings() {

        },
        handlerUpdated(data) {
            this.$emit('updated', data);
        },
    }
}
</script>

<style scoped>

</style>
